export namespace Dashboard {
    export interface DashboardComponentPropsBase<ReportOptionsT = null> {
        reportOptions?: ReportOptionsT;
        reportMode?: boolean
        stateCb?: (res: DashboardComponentState) => void
    }

    export interface IComponentTimed {
        referenceTime?: string;
    }
}

type DashboardComponentLoadingState =  {
    state: "loading";
}

type DashboardComponentErrorState = {
    state: "error";
    error: string;
}

type DashboardComponentFinishedState = {
    "state": "finished"
}

type DashboardComponentState = DashboardComponentFinishedState | DashboardComponentLoadingState | DashboardComponentErrorState
